import * as yup from 'yup';

export const appointmentBookingSchema = (buyerContactList) => {
  return yup
    .object()
    .shape({
      client:
        buyerContactList?.length <= 1
          ? yup.string() // No validation
          : yup.string(),
      service: yup.string().required('Please select a service.'),
      time: yup.string().required('Please select a time.'),
      emailNotify: yup.boolean(),
      mobileNotify: yup.boolean(),
    })
    .test(
      'notificationMethod',
      'Please select at least one notification method.',
      function (values) {
        const { emailNotify, mobileNotify } = values;
        if (!emailNotify && !mobileNotify) {
          return this.createError({
            path: 'emailNotify',
            message: 'Please select at least one notification method.',
          });
        }
        return true;
      }
    );
};
